'use client';

import { Box, Container, Image, Text } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { SectionHeader } from 'components/SectionHeader/SectionHeader';
import { useLocale } from 'next-intl';
import css from './more-than-the-app-section.module.css';
function MoreThanTheApp() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'channelpartners');
  return <Container className={css.container} data-sentry-element="Container" data-sentry-component="MoreThanTheApp" data-sentry-source-file="more-than-the-app-section.tsx">
            <Box className={css.headerWrapper} data-sentry-element="Box" data-sentry-source-file="more-than-the-app-section.tsx">
                <Box className={css.imageWrapper} data-sentry-element="Box" data-sentry-source-file="more-than-the-app-section.tsx">
                    <Image src="/static/channel-partners/represent.png" width={296} height={203} data-sentry-element="Image" data-sentry-source-file="more-than-the-app-section.tsx" />
                </Box>
                <SectionHeader size="base" title={t('mission.title')} subtitle={t('mission.description')} level="3" textAlignment="center" data-sentry-element="SectionHeader" data-sentry-source-file="more-than-the-app-section.tsx" />
            </Box>
            <Box className={css.grid} data-sentry-element="Box" data-sentry-source-file="more-than-the-app-section.tsx">
                <Item title={t('mission.modernWork.title')} description={t('mission.modernWork.description')} data-sentry-element="Item" data-sentry-source-file="more-than-the-app-section.tsx" />
                <Item title={t('mission.longHaul.title')} description={t('mission.longHaul.description15')} data-sentry-element="Item" data-sentry-source-file="more-than-the-app-section.tsx" />
                <Item title={t('mission.growth.title')} description={t('mission.growth.description')} data-sentry-element="Item" data-sentry-source-file="more-than-the-app-section.tsx" />
            </Box>
        </Container>;
}
function Item({
  title,
  description
}: {
  title: string;
  description: string;
}) {
  return <Box className={css.item} data-sentry-element="Box" data-sentry-component="Item" data-sentry-source-file="more-than-the-app-section.tsx">
            <Text size="minor-xl" weight="semibold" data-sentry-element="Text" data-sentry-source-file="more-than-the-app-section.tsx">
                {title}
            </Text>
            <Text data-sentry-element="Text" data-sentry-source-file="more-than-the-app-section.tsx">{description}</Text>
        </Box>;
}
export { MoreThanTheApp };